<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav :selectedLanguage="selectedLanguage" page="blogs" :gotodownload="gotodownload" :apk="apk" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <div class="blog-header">
            <h1>GB WhatsApp Guides &amp; Tips</h1>
            <p>
              Explore practical GB WhatsApp guides for themes, call privacy, app settings, and common issues,
              with clear steps and useful troubleshooting tips.
            </p>
          </div>
          <div class="blog-list-row">
            <a :href="data.url" v-for="(data, i) in doc.bloglist[selectedLanguage].slice().reverse()" :key="i" class="blog-list-item" >
              <div class="blog-list-img">
                <img :src="data.poster" :alt="data.title">
              </div>
              <div class="blog-list-content">
                <h2 class="blog-list-title">
                  {{ data.title }}
                </h2>
                <div class="blog-list-descript">
                  {{ data.desc }}
                </div>
                <div class="blog-list-date">
                  {{ data.date }}
                </div>
              </div>
            </a>
          </div>
        </main>
      </div>
    </div>
  </div>

  <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    Download GBWhatsapp APK
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import doc from '@/documents/blogs.js';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      selectedLanguage: 'en',
      doc: doc,
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    goto(name) {
      // window.location.href = url;
      this.$router.push({
        name: `${name}`
      });
    },
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    gotoHome(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>
